export const PATH = {
  HOME: "/",
  TRENDING: "/trending",
  DISCOVER: "/discover",
  UPCOMING: "/upcoming",
  POPULAR: "/popular",
  TOPRATED: "/top-rated",
  PEOPLE: "/people",
  GENRES: "/genres",
  GENRE: "/genre",
  SHOWMOVIE: "/show/movie",
};
